import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams, ITeamApiListResponse, ITeamDeleteParams, ITeamDeleteResponse, ITeamUpdateParams, ITeamUpdateResponse } from '@/types';

export const teamList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ITeamApiListResponse>> => {
    return axios.get('/api/team/list', { ...config, params });
};

export const teamDelete = (params: ITeamDeleteParams): Promise<AxiosResponse<ITeamDeleteResponse>> => {
    return axios.post('/api/team/delete', params);
};

export const teamUpdate = (params: ITeamUpdateParams): Promise<AxiosResponse<ITeamUpdateResponse>> => {
    return axios.post('/api/team/update', params);
};
